import { parseISO } from 'src/common';

import { Subscription } from './types';

export const transformSubscription = (response: any): Subscription => ({
  price: response.price,
  nextBillingAt: parseISO(response.nextBillingAt),
});
